export default {
    manage_createEditWorkOrderType_editTitle: "Edit Work Order Type",
    manage_createEditWorkOrderType_createTitle: "Create New Work Order Type",
    manage_createEditWorkOrderType_createSuccess: "Work order type saved",
    manage_createEditWorkOrderType_name: "Name",
    manage_createEditWorkOrderType_assingForm: "Assing Form",
    manage_createEditWorkOrderType_description: "Description",
    manage_createEditWorkOrderType_estimatedDurationMins: "Estimated Duration (minutes)",
    manage_createEditWorkOrderType_duplicatedName: "Name is already in use",
}